module.exports = __webpack_public_path__ + "static/img/b3.ee4de5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/zh/b3.png
// module id = FLnW
// module chunks = 0